import LanguageConst from "./language-const";
import LanguageFields from "./fields";
import LanguageForms from "./forms";
import LanguageHelpers from "./helpers";


const Language = {
    Const: LanguageConst,
    Fields: LanguageFields,
    Forms: LanguageForms,
    Helpers: LanguageHelpers,
};

export default Language;
